export default state => {
  return state.list
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/getters/contactForm.js